import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TableSkeletonComponent } from './components/table-skeleton/table-skeleton.component';

@NgModule({
  imports: [CommonModule],
  declarations: [TableSkeletonComponent],
  exports: [TableSkeletonComponent],
})
export class SkeletonModule {}
